(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("wavesurfer.js"), require("react"), require("prop-types"));
	else if(typeof define === 'function' && define.amd)
		define(["wavesurfer", "react", "prop-types"], factory);
	else if(typeof exports === 'object')
		exports["Wavesurfer"] = factory(require("wavesurfer.js"), require("react"), require("prop-types"));
	else
		root["Wavesurfer"] = factory(root["WaveSurfer"], root["React"], root["prop-types"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_1__, __WEBPACK_EXTERNAL_MODULE_2__, __WEBPACK_EXTERNAL_MODULE_3__) {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition